import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum InstitutionFields {
    ACCOUNTING_REF = 'accountingRef',
    ACQUIRED_BY = 'acquiredBy',
    ACQUISITION_STATUS = 'acquisitionStatus',
    ACQUISITION_STATUS_ITEMS = 'acquisitionStatusItems',
    ACTIVATE_AT = 'activateAt',
    ADDRESS = 'address',
    ASSIGNED_EMPLOYEES = 'assignedEmployees',
    AVAILABILITIES = 'availabilities',
    BLOCKED_SLOTS_CALENDAR = 'blockedSlotsCalendar',
    CONTACT_INFORMATION = 'contactInformation',
    COURSE_INFO_TEXT = 'courseInfoText',
    COVID_RECORDS = 'covidRecords',
    CREATED_AT = 'createdAt',
    CUSTOM_ID = 'customId',
    DEACTIVATED_AT = 'deactivatedAt',
    DEACTIVATE_AT = 'deactivateAt',
    EXCEPTIONAL_BLOCKED_SLOTS_CALENDAR = 'exceptionalBlockedSlotsCalendar',
    EXCLUDE_FROM_OPTIMIZATIONS = 'excludeFromOptimizations',
    IS_ACTIVE = 'isActive',
    IS_RENTED = 'isRented',
    LAST_UPDATED_ACQUISITION_STATUS = 'lastUpdatedAcquisitionStatus',
    LAST_UPDATED_ACQUISITION_STATUS_BY = 'lastUpdatedAcquisitionStatusBy',
    NAME = 'name',
    PLANNED_EMPLOYEES = 'plannedEmployees',
    RENT_AMOUNT = 'rentAmount',
    RENT_INTERVAL = 'rentInterval',
    RENT_NOTE = 'rentNote',
    RESPONSIBLES = 'responsibles',
    STATUS = 'status',
    SUPERVISOR = 'supervisor',
    TAGS = 'tags',
    TOTAL_AMOUNT_PUPILS = 'totalAmountPupils',
    TYPE = 'type',
    UPDATED_AT = 'updatedAt',
    HANDOUT_EVENT = 'handoutEvents',
    HANDOUT_EVENT_DEVIATIONS = 'handoutEventDeviations',
    EMPLOYEES_WANTED = 'employeesWanted',
    META_EMPLOYEE_ADS = 'metaEmployeeAds',
    APPLICANTS = 'applicants',
}

export namespace InstitutionFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<InstitutionFields, Data> = {
        [InstitutionFields.ACCOUNTING_REF]: {text: 'Referenz zur Buchhaltung'},
        [InstitutionFields.ACQUIRED_BY]: {text: 'Akquirierende Mitarbeiter:in'},
        [InstitutionFields.ACQUISITION_STATUS]: {text: 'Status der Akquise'},
        [InstitutionFields.ACQUISITION_STATUS_ITEMS]: {text: 'Verlauf der Akquise'},
        [InstitutionFields.ACTIVATE_AT]: {text: 'Bevorstehendes Aktivierungsdatum'},
        [InstitutionFields.ADDRESS]: {text: 'Anschrift'},
        [InstitutionFields.ASSIGNED_EMPLOYEES]: {text: 'Zugewiesene Mitarbeiter:innen'},
        [InstitutionFields.AVAILABILITIES]: {text: 'Verfügbarkeiten'},
        [InstitutionFields.BLOCKED_SLOTS_CALENDAR]: {text: 'Blockierte Zeitslots'},
        [InstitutionFields.CONTACT_INFORMATION]: {text: 'Kontaktinformationen'},
        [InstitutionFields.COURSE_INFO_TEXT]: {text: 'Kursinformationen'},
        [InstitutionFields.COVID_RECORDS]: {text: 'Inzidenzverlauf (COVID-19)'},
        [InstitutionFields.CREATED_AT]: {text: 'Erzeugungsdatum', readOnly: true},
        [InstitutionFields.CUSTOM_ID]: {text: 'Standortnummer'},
        [InstitutionFields.DEACTIVATED_AT]: {text: 'Deaktiviert am', readOnly: true},
        [InstitutionFields.DEACTIVATE_AT]: {text: 'Bevorstehendes Deaktivierungsdatum'},
        [InstitutionFields.EXCEPTIONAL_BLOCKED_SLOTS_CALENDAR]: {text: 'Ausnahmen blockierter Zeitslots'},
        [InstitutionFields.EXCLUDE_FROM_OPTIMIZATIONS]: {text: 'Von Optimierungen ausschließen'},
        [InstitutionFields.IS_ACTIVE]: {text: 'Ist aktiv'},
        [InstitutionFields.IS_RENTED]: {text: 'Ist gemietet'},
        [InstitutionFields.LAST_UPDATED_ACQUISITION_STATUS]: {text: 'Letzte Aktualisierung des Akquisestatus'},
        [InstitutionFields.LAST_UPDATED_ACQUISITION_STATUS_BY]: {text: 'Letzte Aktualisierung des Akquisestatus durch'},
        [InstitutionFields.NAME]: {text: 'Name'},
        [InstitutionFields.PLANNED_EMPLOYEES]: {text: 'Geplante Mitarbeiter:innen'},
        [InstitutionFields.RENT_AMOUNT]: {text: 'Mietbetrag'},
        [InstitutionFields.RENT_INTERVAL]: {text: 'Mietintervall'},
        [InstitutionFields.RENT_NOTE]: {text: 'Mietnotiz'},
        [InstitutionFields.RESPONSIBLES]: {text: 'Verantwortliche'},
        [InstitutionFields.STATUS]: {text: 'Status'},
        [InstitutionFields.SUPERVISOR]: {text: 'Betreuer:in'},
        [InstitutionFields.TAGS]: {text: 'Tags'},
        [InstitutionFields.TOTAL_AMOUNT_PUPILS]: {text: 'Gesamtanzahl Schüler:innen'},
        [InstitutionFields.TYPE]: {text: 'Art des Standorts'},
        [InstitutionFields.UPDATED_AT]: {text: 'Aktualisiert am', readOnly: true},
        [InstitutionFields.HANDOUT_EVENT]: {text: 'Werbeaktionen'},
        [InstitutionFields.HANDOUT_EVENT_DEVIATIONS]: {text: 'Abweichungen bei Ausgabeterminen'},
        [InstitutionFields.EMPLOYEES_WANTED]: {text: 'Mitarbeiter:innen gesucht'},
        [InstitutionFields.META_EMPLOYEE_ADS]: {text: 'Meta-Stellenanzeigen'},
        [InstitutionFields.APPLICANTS]: {text: 'Bewerber:innen'},
    };

    export const Items = mapRecordToItems(Record);
}
